import { useCallback, useContext } from "react";
// import { useNavigate } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { googleLogout } from "@react-oauth/google";
// import { FacebookLoginClient } from "../components/FacebookLogin/facebook-login.client";
import { GRAPHQL_SCHEMA } from "../config/gql-schemas";
import { removeItem } from "../utils/LocalStorage";
import { AuthContext } from "../context";
import { ModalContext } from "../context/modalContext";
import useRedirectHandler from "./redirectHandler";

export default function useLogoutHandler() {
    const { setUnauthStatus, setToastList, setGlobalLoading } = useContext(AuthContext);
    const { closeModal } = useContext(ModalContext);

    const [_logoutUser] = useLazyQuery(GRAPHQL_SCHEMA.logoutUser);

    const { redirectToBase } = useRedirectHandler();

    const logout = useCallback(async () => {
        setGlobalLoading(true);
        console.log("Your logging out of application");
        closeModal("logoutAlert");
        closeModal("logoutConfirmationModal");
        closeModal("unauthorizedAlert");
        // setUserAuth(DEFAULT_USER_AUTH);
        // FacebookLoginClient.logout(() => {
        //     console.log("logout completed!");
        // });
        // Sign out from Google
        googleLogout();
        setUnauthStatus();
        setToastList([]);
        await _logoutUser({
            context: {
                clientName: "adminAuth",
            },
        });
        removeItem("isAdmin");
        // setisProfile(false);
        setGlobalLoading(false);
        redirectToBase();
    });

    return { logout };
}
